import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=a57aa682&scoped=true"
import script from "./BaseLogo.vue?vue&type=script&lang=js"
export * from "./BaseLogo.vue?vue&type=script&lang=js"
import style0 from "./BaseLogo.vue?vue&type=style&index=0&id=a57aa682&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57aa682",
  null
  
)

export default component.exports